"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CREATE_AUDIT_QUESTION = void 0;
var client_1 = require("@apollo/client");
var fragments_1 = require("../fragments");
exports.CREATE_AUDIT_QUESTION = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation CreateAuditQuestion($input: CreateAuditQuestionInput!) {\n    createAuditQuestion(input: $input) {\n      auditQuestion {\n        ...AuditQuestion\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation CreateAuditQuestion($input: CreateAuditQuestionInput!) {\n    createAuditQuestion(input: $input) {\n      auditQuestion {\n        ...AuditQuestion\n      }\n    }\n  }\n  ", "\n"])), fragments_1.AUDIT_QUESTION_FRAGMENT);
var templateObject_1;
